(ns teamoesterreich.admin-mode.warnings.warnung-list
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [teamoesterreich.admin-mode.actions :as a]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.view-state :as v-state]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.date :as h-date]
            [teamoesterreich.util.helper :as h]
            [teamoesterreich.admin-mode.modal.create-with-name-modal :as create-with-name-modal]
            [teamoesterreich.admin-mode.component.ws-event-sync-component :as ws-event-sync-component]
            [teamoesterreich.admin-mode.data.rights :as d-rights]
            [teamoesterreich.admin-mode.data.warning :as d-warning]
            [reagent-material-ui.icons.add :refer [add]]
            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.info :refer [info]]
            [reagent-material-ui.icons.refresh :refer [refresh]]
            ))





(defn date-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)
        l-date (if (> cell-data 893462400000)
                 (h-date/print-google-date (h-date/parse-unix-date cell-data))
                 "-")
        ]
    (js/console.log l-date)
    (r/as-element
      [:span l-date])))



(defn edit-cell-renderer [!selected]
  (fn [js-parm]
    (let [{cell-data "cellData"} (js->clj js-parm)]
      (r/as-element
        (if (d-rights/is-superuser?)
          [mui/icon-button {:label   "bearbeiten"
                            :onClick (fn []
                                       (reset! !selected cell-data)
                                       (a/set-page :warning-edit))
                            } [edit {:fontSize "small"}]]

          [mui/icon-button {:label   "details"
                            :onClick (fn []
                                       (reset! !selected cell-data)
                                       (a/set-page :warning-edit))
                            } [info {:fontSize "small"}]])))))


(defn inside-table [!st rows]

  (fn [m]
    (let [width (aget m "width")
          height (aget m "height")
          !selected (r/cursor v-state/app-state [:warning-list :selected])
          !sort (r/cursor !st [:sort])
          !reverse (r/cursor !st [:reverse])
          ]
      (r/as-element
        [:> rv/Table
         {:headerHeight    50
          :height          (- height 250)
          :rowCount        (count rows)
          :rowGetter       (fn [i]
                             ;(println (str "rowGet " (aget i "index")))
                             (clj->js (nth rows (aget i "index"))))
          :rowClassName    (fn [i] (when (odd? (aget i "index")) "table-odd"))
          :sort            (fn [s] (swap! !st assoc :sort (aget s "sortBy") :reverse (= "DESC" (aget s "sortDirection")) :invalidated true))
          :sortBy          @!sort
          :sortDirection   (if @!reverse "DESC" "ASC")
          :rowHeight       45
          :width           width
          :headerClassName "headerColumn"
          :className       "OrganisationList"}
         (log/debug "rerender " m " @!sort " @!sort " @!reverse " @!reverse rows)

         [:> rv/Column
          {:label        "#"
           :dataKey      (name :warningCap-uuid)
           :className    "bordered exampleColumn"
           :cellRenderer (edit-cell-renderer !selected)
           :width        70}]

         [:> rv/Column
          {:label     "Quelle"
           :dataKey   (name :warningCap-source)
           :className "bordered exampleColumn"
           :style     {:overflow "hidden"}
           :width     220}]

         [:> rv/Column
          {:label     "Typ"
           :dataKey   (name :warningCap-event)
           :className "bordered exampleColumn"
           :style     {:overflow "hidden"}
           :width     100}]
         [:> rv/Column
          {:label     "Level"
           :dataKey   (name :warningCap-level)
           :className "bordered exampleColumn"
           :style     {:overflow "hidden"}
           :width     100}]


         [:> rv/Column
          {:label        "Von"
           :dataKey      (name :warningCap-start)
           :cellRenderer date-renderer
           :className    "bordered exampleColumn"
           :style        {:overflow "hidden"}
           :width        120}]
         [:> rv/Column
          {:label        "bis"
           :dataKey      (name :warningCap-end)
           :cellRenderer date-renderer
           :className    "bordered exampleColumn"
           :style        {:overflow "hidden"}
           :width        120}]

         [:> rv/Column
          {:label     "Text"
           :dataKey   (name :warningCap-headline)
           :className "bordered exampleColumn"
           :style     {:overflow "hidden" :textAlign "left"}
           :width     420}]

         [:> rv/Column
          {:label     "Massnahme"
           :dataKey   (name :warningCap-instruction)
           :className "bordered exampleColumn"
           :style     {:overflow "hidden"}
           :width     420}]

         ]))))




(defn filter-fn [data !st]
  (log/debug "filter-fn " (count data) (clj->js data))
  (filter (fn [[k e]] (re-find (re-pattern (reduce (fn [c e] (str c "(?=.*" e ")")) "(?i)^" (clojure.string/split (:search @!st) " ")))
                               (str (:warningCap-headline e) "#" (:warningCap-description e))))
          data))

(defn update-list [!st]
  (h/update-table-list !st d-warning/<get-warning-list {:filter-fn filter-fn :default-sort :warningCap-headline}))



(defn get-table [!st !rows]
  (fn [] [:> rv/AutoSizer
          {:style {:height "100%" :minHeight "400px"}
           :sort  (str "rerender !st" @!st)}
          (inside-table !st @!rows)]))


(defn get-it []
  (let [!st (r/atom {:rows {} :loaded nil :create-modal-show nil})]
    (fn []

      (let [!create-modal (r/cursor !st [:create-modal-show])
            !loaded? (r/cursor !st [:loaded])
            !rows (r/cursor !st [:rows])
            ]
        (update-list !st)
        (log/debug "!st == " (clj->js @!st))
        (if (not @!loaded?)
          (do [:div {:style {:marginTop "100px"}} [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}] "  loading..."])


          [mui/paper
           [create-with-name-modal/modal
            !create-modal
            "Bitte gib einen Titel für die Warnung ein"
            "Erstellen"
            (fn [name]
              (log/debug "Create warning with header: " name)

              )
            ]
           [mui/grid
            {:container  true
             :direction  "row"
             :alignItems "stretch"
             :justify    "flex-start"
             :spacing    1
             :style      {:marginTop "15px" :height "100%" :minHeight "400px"}
             }

            [mui/grid
             {:item true
              :lg   2
              :md   3
              :xs   6
              }

             [mui/button {:startIcon (r/as-element [add]) :color "secondary" :variant "outlined" :style {:margin "5px 40px 5px 0"}
                          :onClick   #(reset! !create-modal true)
                          }
              "Neue Warnung"]
             ]
            [mui/grid
             {:item true
              :lg   8
              :md   6
              :xs   6
              :type {:textAlign "bottom"}
              }
             [mui/typography {:variant "h5" :padding "5px 0 0 0"}
              " Warnung Liste "]
             ]
            [mui/grid
             {:item true
              :lg   2
              :md   3
              :xs   6
              }
             [ws-event-sync-component/ws-event-reload !loaded? :warning]
             ]
            [mui/grid
             {:item true
              :xs   12
              }
             [get-table !st !rows]
             ]
            ]

           ]))
      )))









(defn get-it-mt []
  (fn []
    (log/debug "Ticket Maintenance")
    [:h3 "Maintenance"]))